import {Component, Vue} from 'vue-property-decorator';
import * as api from '@/store/api';
import DokumentWrapper from '@/pdf/DokumentWrapper';

@Component
export default class Report extends Vue {
    doc: any | null = null;
    loaded: boolean = false;

    async loadDocument() {
        const documentId = this.$route.params.DocumentId;
        this.doc = new DokumentWrapper(await api.getDocument(documentId, true));
        this.doc.isPrint = this.isPrint;
        this.loaded = true;
    }

    async loadQuick(subType: string) {
        const UserId = this.$route.params.UserId;
        const Version = this.$route.params.Version;
        const OrgNr = this.$route.params.OrgNr;
        const SieId = this.$route.params.SieId;
        this.doc = new DokumentWrapper(await api.getQuick(UserId, Number(Version), OrgNr, Number(SieId), true));
        this.doc.isPrint = this.isPrint;
        this.doc.doc.SubType = subType;
        this.loaded = true;
    }

    get isPrint(): boolean {
        if (
            !this.$router ||
            !this.$router.currentRoute ||
            !this.$router.currentRoute.name
        ) {
            return false;
        }
        return this.$router.currentRoute.name.endsWith('print');
    }
}
